<template>
	<a :href="url" class="btn btn-primary btn-lg btn-embossed" :class="buttonClass" @click="scrollUp">
		<span v-if="direction === 'next' && finalTest" v-translate>Finish </span>
		<span v-if="direction === 'next' && !finalTest" v-translate>Next Test </span>
		<i class="fa" :class="icon"></i>
		<span v-if="direction === 'prev'" v-translate> Previous Test</span>
	</a>
</template>

<script>
/**
 * Button to Navigate through the tests.
 * Can navigate to previous or next depending on the props provided
 */
export default {
	name: 'PrevNextButton',
	data () {
	  return {}
 	},
  props: {
	  /**
    * String (prev|next) signifying whether button is a previous or next button
    */
		direction: { type: String, default: 'prev' },
		/**
     * String (fa-prev|fa-next) to be added to the icon in the button
     * */
		icon: { type: String, default: 'fa-prev' },
    /**
     * String containing the url of where the button will navigate to when clicked
     * */
		url: { type: String },
		/**
     * Boolean stating whether this is the final test. Render a different button label if it is
     * */
		finalTest: { type: Boolean, 'default': false }
  },
  computed: {
	  buttonClass () {
      return this.direction + '-test'
    }
  },

  methods: {
    scrollUp (e) {
      window.scrollTo(0, 0)
    }
  }
}

</script>

<style scoped>

</style>
